module.exports = __webpack_public_path__ + "img/stat-icon-1.5ab3931e.svg";